/**
 * TargetModuleCountInput - Input field for target module count
 *
 * Numeric input with keyboard filtering for specifying max module count.
 */

import React from 'react';

interface TargetModuleCountInputProps {
  value: number | null;
  onChange: (value: number | null) => void;
}

export function TargetModuleCountInput({ value, onChange }: TargetModuleCountInputProps) {
  return (
    <div>
      <label className="block font-semibold text-gray-700 mb-1">
        Target Module Count
      </label>
      <input
        type="text"
        inputMode="numeric"
        value={value ?? ''}
        onChange={(e) => {
          const val = e.target.value.trim();
          if (val === '') {
            onChange(null);
          } else {
            const num = parseInt(val);
            if (!isNaN(num) && num >= 1) {
              onChange(num);
            }
          }
        }}
        onKeyDown={(e) => {
          // Allow navigation and editing keys
          const allowedKeys = [
            'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
            'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
            'Home', 'End'
          ];

          if (allowedKeys.includes(e.key)) {
            return;
          }

          // Allow Ctrl/Cmd + A, C, V, X
          if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) {
            return;
          }

          // Only allow digits
          if (!/^\d$/.test(e.key)) {
            e.preventDefault();
          }
        }}
        placeholder="Auto (no limit)"
        className="w-full px-2 py-1 border border-gray-300 rounded text-xs"
      />
      <p className="text-xs text-gray-500 mt-1">
        Leave empty for automatic mode
      </p>
    </div>
  );
}

export default TargetModuleCountInput;
